// extracted by mini-css-extract-plugin
export default {"layout":"styles_layout__JxlnL","container":"styles_container__L8sno"};